export class Service {
    constructor(service) {
        this.id = service.id;
        this.pdf = service.pdf;
        this.title = service.title;
    }
}